// src/Header.js
import React from "react";
import { useNavigate } from "react-router-dom";
import "./Header.css";

export default function Header({ showBack }) {
  const navigate = useNavigate();

  return (
    <header className="site-header">
      {showBack && (
        <button className="back-button" onClick={() => navigate(-1)}>
          ← Back
        </button>
      )}

      <h1 className="header-title">The Finding Spot</h1>
    </header>
  );
}
